import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PendingChangesGuard } from '@check-list/app/shared/guards/pending-changes.guard';
import { InspectionDetailsComponent } from './inspection-details/inspection-details.component';
import { InspectionDraftComponent } from './inspection-draft/inspection-draft.component';

const routes: Routes = [
  {
    path: ':id/draft',
    component: InspectionDraftComponent,
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: ':id',
    component: InspectionDetailsComponent,
    canDeactivate: [PendingChangesGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InspectionsRoutingModule {}
